export default __webpack_public_path__ + "static/media/crosshair.06b11b4d.svg";